module.exports = __webpack_public_path__ + "static/media/close-menu.d5ab2e32.svg";